import * as React from "react";
import { TextInput } from "../TextInput";
import { FormPhoneInput } from "../FormPhoneInput";

export function InsuredContactInfo({ register, setValue }) {
  return (
    <div className="rounded-lg border p-4 space-y-4">
      <h3 className="text-lg font-semibold">Insured Contact Info</h3>

      <div className="grid gap-4 md:grid-cols-2">
        <TextInput
          register={register}
          label={"First Name"}
          id={"insured-first"}
          stepName={"step2.insuredContact.firstName"}
          stepId={"step2"}
        />
        <TextInput
          register={register}
          label={"Last Name"}
          id={"insured-last"}
          stepName={"step2.insuredContact.lastName"}
          stepId={"step2"}
        />
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <TextInput
          register={register}
          label={"Email Address"}
          id={"insured-email"}
          stepName={"step2.insuredContact.email"}
          stepId={"step2"}
        />
        <FormPhoneInput
          register={register}
          setValue={setValue}
          label={"Phone Number"}
          id={"insured-phone"}
          stepName={"step2.insuredContact.phone"}
          stepId={"step2"}
        />
      </div>
    </div>
  );
}
